import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNav.css';

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path === '/upload' && location.pathname === '/upload') return true;
    return false;
  };

  const isOnBoard = location.pathname.startsWith('/board/') || location.pathname.startsWith('/join/');

  return (
    <nav className="bottom-nav">
      <button
        className={`bottom-nav__item ${isActive('/') ? 'bottom-nav__item--active' : ''}`}
        onClick={() => navigate('/')}
      >
        <span className="bottom-nav__icon">🧾</span>
        <span className="bottom-nav__label">Мои чеки</span>
      </button>

      <button
        className="bottom-nav__item bottom-nav__item--upload"
        onClick={() => navigate('/upload')}
      >
        <span className="bottom-nav__icon-circle">
          <span className="bottom-nav__icon-plus">📸</span>
        </span>
        <span className="bottom-nav__label">Загрузить</span>
      </button>

      <button
        className={`bottom-nav__item ${isActive('/about') || isOnBoard ? '' : ''} ${location.pathname === '/about' ? 'bottom-nav__item--active' : ''}`}
        onClick={() => navigate('/about')}
      >
        <span className="bottom-nav__icon">ℹ️</span>
        <span className="bottom-nav__label">О нас</span>
      </button>
    </nav>
  );
};

export default BottomNav;
